export const dropdownTriggers = ['hover', 'click']
export const dropdownContextKey = Symbol('dropdownContextKey')
